import { Flex, Tab, TabList, Text, Link } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";

export function ChakraTabs(props) {
  const { tabs, baseUrl } = props;
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Flex w="100%">
      <TabList border="1px solid #E5E7EB" borderRadius="10px" p="6px" gap="8px" bg="#F8FAFC" w={{ base: "100%", md: "max-content" }}>
        {tabs.map((tab) => {
          const tabUrl = `${baseUrl || location.pathname}?tab=${tab.id}`;
          return (
            <Tab
              key={tab.id}
              fontWeight={500}
              fontSize="14px"
              color="#5C657E"
              borderRadius="8px"
              px="0px"
              py="0px"
              _selected={{
                color: "white",
                bg: "#3B82F6",
              }}
              _hover={{ opacity: 0.8 }}
              flex="1 1 0"
              cursor="pointer"
              w="max-content"
            >
              <Link
                px="16px"
                py="8px"
                href={tabUrl}
                _hover={{ textDecoration: "none" }}
                onClick={(e) => {
                  if (!e.ctrlKey && !e.metaKey && e.button !== 1) {
                    e.preventDefault();
                    navigate(tabUrl);
                  }
                }}
                style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "max-content", height: "100%" }}
              >
                <Flex gap={3} h={5} alignItems="center">
                  <Text>{tab.label}</Text>
                </Flex>
              </Link>
            </Tab>
          );
        })}
      </TabList>
    </Flex>
  );
}
